import React, {Component, Fragment} from 'react';
import WorthyApi from 'lib/api/worthyApi';
import {isMobile, imageUrl, dollarsWithoutCents} from 'helpers/ApplicationHelper';
import {siteItemPage, haveProperties, getStatus} from 'helpers/itemHelper';
import ThreeDotsMenu from 'components/myAccount/threeDotsMenu';
import {
    ON_HOLD,
    PENDING_SALE,
    SALE_SCHEDULED,
    EVALUATION_READY,
    DONE,
    DELIVERED,
    EVALUATION_BID_ASSORTED,
    PENDING_AUCTION,
    isShipBack,
} from "../../helpers/ApplicationHelper";
import popupSubmitItemCancelleation from "../popups/popupSubmitItemCancellation";
import {getUserBundles, getBundleWithItems} from 'actions/myAccount';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

class ItemDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            item: this.props.item,
            bundles: props.MyAccount && props.MyAccount.bundles || []
        };
        this.viewItem = this.viewItem.bind(this);
        this.cancelShipBackRequest = this.cancelShipBackRequest.bind(this);
        this.renderParent= this.renderParent.bind(this);
    }

    get item() {
        return this.state.item;
    }

    /**
   *
   * @returns {boolean}
   */
  get isJewelryBox() {
      return this.props.bundleType === 'jewelry_box';
    }

    /**
     *
     * @returns {boolean}
     */
    get isConvertedToJBFromSTDBundle() {
        return this.props?.bundle?.converted_from_std_bundle;
    }

  /**
   * Check if Standard items should be clickable
   *
   * @returns {boolean}
   */
  get areStandardItemsClickable() {
    return !this.item.aborted
        && ![ DELIVERED, DONE, EVALUATION_BID_ASSORTED].includes(this.item.workflow_state)
        && this.item.location !== 'shipped_back_to_seller'
        && this.pendingSaleCondition;
  }

  /**
   *
   * @returns {boolean|*}
   */
  get clickable() {
    if (isShipBack(this.item)) {
      return true;
    }

    if (this.item.workflow_state === PENDING_AUCTION && this.item.format === 'tender') {
        return false;
    }

    if (this.item.is_direct_offer) {
      return false;
    }

    return (this.item?.pre_evaluation_ready && this.props?.bundle?.converted_from_std_bundle) ||
        !this.item?.restrict_jb_seller_enter_pending_auction && this.areStandardItemsClickable && haveProperties(this.item);
  }

    get pendingSaleCondition() {
        return this.item.workflow_state === PENDING_SALE ? this.props.clickablePendingSale : true;
    }


    get boldable() {
        return this.item.workflow_state === DELIVERED && this.item.location !== 'worthy_ny' &&
          this.props.lastViewed && (new Date(this.item.location_created).getTime() > new Date(this.props.lastViewed).getTime())
    }

    renderStatus() {
      const item = this.item;
      const { bundle } = this.props;
      const statusLabel = getStatus(bundle, item, 2);

      if ([EVALUATION_READY, PENDING_SALE].includes(item.workflow_state) && this.props.allFinished) {
          return <div className='green'>{ statusLabel }</div>
      }

      if ([ON_HOLD, SALE_SCHEDULED, DONE].includes(item.workflow_state) && !item.aborted) {
        if (this.props.bundleType === 'standard') {
          if (!item.minimum_price_met) {
              return <div className='green'>{ statusLabel }</div>;
          } else {
              return (<Fragment>
                <div className='green'>Concluded</div>
                <div className='after-star'>Above reserve</div>
              </Fragment>);
            }
        } else return <div className='green'>{ statusLabel }</div>;
      }
      return statusLabel;
    }

    renderCta() {
        let cta;

        if(this.item.restrict_jb_seller_enter_pending_auction);
        else if (this.item.workflow_state === 'pending_auction' && this.item.format !== "tender" && !this.item.scheduled_auction)
            cta = <button className='cta btn btn-orange start-auction' onClick={this.viewItem}>Start auction</button>;
        else if (this.item.return_requested && this.item.workflow_state !== 'return_pending')
            cta = <a className='cta cancel-request' onClick={this.cancelShipBackRequest}>Cancel request</a>;
        return <span className='cta-container'>{cta}</span>;
    }

    renderPrice() {
        return (
            <span className={`price ${this.item.return_requested ? 'crossed-out' : ''}`}>
                {
                    ((this.props.allFinished || this.item.minimum_price_met) && // if all items finished OR this item finished above reserve
                        (!this.item.aborted && !this.item.return_requested && this.item.workflow_state !== "return_pending")) ? // if item isn't aborted or shipped back
                            dollarsWithoutCents(Math.max(this.item.highest_bid, (this.item.advance_payment || this.item.price_guarantee) && this.item.reserve_price || 0))
                            :
                            null
                }
            </span>);
    }

    viewItem() {
        if (this.isJewelryBox && this.isConvertedToJBFromSTDBundle) {
            return window.location.pathname = `/item/${this.item.public_id}`;
        } else if (this.isJewelryBox && this.item.pre_shipping) {
                window.location.pathname = `/multiple_jewelry/${this.props.bundleId}`;
        } else if (this.item.workflow_state === 'evaluation_bid') {
            window.location = siteItemPage(this.item.public_id);
        } else {
            window.location.pathname = `/item/${this.item.public_id}`;
        }
    }

    cancelShipBackRequest() {
        WorthyApi.cancelShipBackRequest(this.item.public_id).then(() => {
            this.setState({item: Object.assign(this.item, { return_requested: false })})
        })
    }
    renderThreeDotsMenu() {
        return ( <div className="three-dots-wrapper">
            <ThreeDotsMenu
                options={[
                    {
                        optionText: 'Cancel submission',
                        handler: () => {
                            return popupSubmitItemCancelleation.initPopup({
                                itemPublicId: this.item.public_id,
                                rerenderParentCallback: ()=>this.renderParent()
                            });
                        },
                        optionIconUrl: imageUrl('common/abortItem.png')
                    }]}
            />
        </div>)
    }

    renderParent = ()=>{

        this.props.rerenderParentCallback()

    }

    render() {
        let cta = this.renderCta(),
            status = this.renderStatus(),
            mobile = isMobile();
        if (mobile && cta.props.children) status = null;
        return (
            <div className={`item-detail ${this.clickable ? 'clickable' : ''}`} onClick={this.clickable ? this.viewItem : null}>
                <div className='img-container'>
                    {
                        this.item.major_subset_type !== 'Other' &&
                        <img src={this.item.image || imageUrl(`myAccount/${this.item.major_subset_type.toLowerCase()}.svg`)} />
                    }
                </div>
                <span className='headline'>
                    <div className={`title ${this.props.bundleCount === 1 ? 'hide' : ''}`}>{`#${this.item.public_id}`}</div>
                    <div className='text-truncate'>{this.item.desc}</div>
                    { mobile ? cta : null }
                </span>
                <span className='container-status'>
                    <span className={`new-label ${this.boldable ? '' : 'hide'}`}>New</span>
                    <span className={`status ${this.boldable ? 'bold' : ''}`}>{status}</span>
                </span>
                { mobile ? null : cta }
                {this.renderPrice()}
                {this.props.cancelItemOption && this.item.pre_shipping && this.renderThreeDotsMenu()}
            </div>
        )
    }
}

const mapStateToProps = ({ ADO, MyAccount, Personalized, Session}) => {
    return { ADO, MyAccount, P13N: Personalized, Session }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getUserBundles,
        getBundleWithItems
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemDetails);
